import Joi from '@hapi/joi';
import { Login } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<Login>>({
  password: Joi.string().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export default function (value: Partial<Login>) {
  return validate(schema, value, {
    context: {},
  });
}
